import React from 'react';

const Spinner = ({theme, size}) => {
    let className = (theme === 'light' ? 'light' : 'dark');
    className = className  +  (size  === ' large' ? ' large' : ' small');

    return (
        <div className={`spinner ${className}`}></div>
    );
};

export default Spinner;


// WEBPACK FOOTER //
// ./src/components/commons/spinner/spinner.js